<nav class="sidebar" [ngClass]="{'hidden': hideSideNav}">
    <div class="d-flex justify-content-end" style="margin-top: 5px; margin-right: 10px; z-index: 99999;">
        <a style="background-color: #499; border: 1.5px solid #499;color: #ffffff;border-radius: 3px;z-index: 999;"
            (click)="hideSideBar()">
            <span *ngIf="!hide"><i class="fas fa-angle-double-right fa-2x " style=" margin: 0px auto; "></i></span>
            <span *ngIf="hide"><i class="fas fa-angle-double-left fa-2x "
                    style="display: flex; margin: 0px auto; "></i></span>
        </a>
    </div>

    <div *ngIf="hide">
        <div class="logo d-flex justify-content-start" style="width: 110%; margin: -45px -3px 0px -4px; ">
            <a><img src="assets/bk_logo.png" alt="" [routerLink]="['/core']"></a>
        </div>

        <div class="matacco" style="margin-top: -15px;">

            <mat-accordion>

                <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
                    *ngFor="let menu of menuList; index as i" (click)="menuClick(i)">

                    <mat-expansion-panel-header style="background-color: #499;">

                        <mat-panel-title style="color: #ffffff;">
                            {{menu.functionShortName}}
                        </mat-panel-title>

                    </mat-expansion-panel-header>

                    <div style="margin: 8px 0px -10px 14px;" >
                        <ul  *ngFor="let submenu of subMenuList; index as i">
                            <li class="subMenu" (click)="subMenuClick(submenu)">{{submenu.subFunctionShortName}}</li>
                        </ul>
                    </div>
                    
                    <!-- <div style=" margin-left: -22px;">
                        <mat-expansion-panel style=" width: 250px;" (opened)="panelOpenState = true"
                            (closed)="panelOpenState = false" *ngFor="let submenu of subMenuList; index as i"
                            (click)="subMenuClick(submenu)">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{submenu.subFunctionShortName}}
                                </mat-panel-title>
                            </mat-expansion-panel-header>

                        </mat-expansion-panel>
                    </div> -->

                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>

</nav>